import { Instance } from 'mobx-state-tree';
import { DriverStopActionDtoModelBase } from './DriverStopActionDtoModel.base';

/* The TypeScript type of an instance of DriverStopActionDtoModel */
export interface DriverStopActionDtoModelType extends Instance<typeof DriverStopActionDtoModel.Type> {}

/* A graphql query fragment builders for DriverStopActionDtoModel */
export { selectFromDriverStopActionDto, driverStopActionDtoModelPrimitives, DriverStopActionDtoModelSelector } from './DriverStopActionDtoModel.base';

/**
 * DriverStopActionDtoModel
 */
export const DriverStopActionDtoModel = DriverStopActionDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
